/**
 * Presentación del estado de un conduce x mayor.
 *
 * A diferencia de [[lib/consignaciones]], aquí NO se deriva nada: la regla vive
 * en el servidor (app/conducesxmayor.py::estado_conduce) y el listado, el
 * detalle y el conduce impreso reciben la clave ya calculada. Este módulo solo
 * la traduce a etiqueta y color, para que las tres pantallas pinten el mismo
 * chip y no vuelva a pasar lo de las consignaciones de entrada, donde tres
 * pantallas calculaban el estado a mano y las tres discrepaban.
 *
 * Sin clave conocida se devuelve un chip neutro con el texto tal cual: es mejor
 * mostrar "—" que afirmar "Facturado" por una respuesta incompleta.
 */

const ESTADOS = {
  anulado: { label: "Anulado", variant: "danger" },
  // Naranja a propósito: es el único estado que exige una acción del usuario
  // (el cliente ya vendió y hay que emitirle la factura).
  porfacturar: { label: "Por facturar", variant: "warning" },
  enpiso: { label: "En piso", variant: "info" },
  facturado: { label: "Facturado", variant: "success" },
};

/**
 * @param {object} row fila de conduce con `estado` (clave del servidor)
 * @returns {{clave: string, label: string, variant: string}}
 */
export function estadoConduce(row = {}) {
  const clave = String(row.estado || "").trim();
  const est = ESTADOS[clave];
  if (!est) return { clave: "", label: row.estadoLabel || "—", variant: "neutral" };
  return { clave, ...est };
}

export default estadoConduce;
